export default __webpack_public_path__ + "static/media/ImagePreview.3d6621b4.svg";